import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import __i18n from "../../../../../intl/__i18n";
import {PlatformOptions} from "../../../../../models";

function NewUsersChart({data, intl}) {
  return(
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column',
            height:250,
          },
          title: {
            text: __i18n("New Devices")
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter: function () {
                return PlatformOptions.find(opt => opt.value === this.value).label
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Count")
            }
          },
          legend: {
            enabled: false
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px"></span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          series: [{
            name:__i18n("Count"),
            data: data.map(item => ([ item.platform, item.total ])),
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(NewUsersChart);

